"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var modules = [{
  text: 'Suspeita de fraude',
  value: 'DENOUNCED_AS_FRAUD'
}, {
  text: 'Propaganda indevida ou spam',
  value: 'DENOUNCED_AS_SPAMMER'
}, {
  text: 'Insulto verbal ou xingamento',
  value: 'DENOUNCED_AS_DISRESPECTFUL'
}, {
  text: 'Assédio sexual ou discriminação',
  value: 'DENOUNCED_AS_HARASSMENT'
}, {
  text: 'Modo de pagamento suspeito',
  value: 'DENOUNCE_AS_SUSPECT_PAYMENT'
}, {
  text: 'Não quer marcar em local público',
  value: 'DENOUNCE_BAD_MEETING_PLACE'
}, {
  text: 'Quer negociar fora da OLX',
  value: 'DENOUNCE_OFF_OLX_NEGOTIATION'
}, {
  text: 'Oferta proibida, ilegal ou ofensiva',
  value: 'DENOUNCE_AS_ILLEGAL_OR_OFFENSIVE_OFFER'
}, {
  text: 'Preço enganoso ou errado',
  value: 'DENOUNCE_DECEPTIVE_PRICE'
}, {
  text: 'Não recebo resposta',
  value: 'DENOUNCE_NON_RESPONSE'
}];
var _default = exports["default"] = modules;